<template>
    <div id="SQLSync">
        <!-- <Breadcrumb :list="list"/> -->
        <div v-if="loader || loader1 || modalLoader">
            <Loader />
        </div>
        <div v-else>
            <div class="datepickerwrap card top-card">
                <div class="left-card">
                    <div class="custom_dropdown customMultiselect">
                        <multiselect v-model="getSelectedWebsites" :options="websiteMenuItems" :multiple="true"
                            group-values="options" group-label="optgroup" :group-select="true"
                            placeholder="Search Website(s)" select-label="" deselect-label="" selectedLabel=""
                            :closeOnSelect="false" selectGroupLabel="Select Group" deselectGroupLabel="Deselect Group"
                            @select="setSelectedWebsites($event)" @remove="removeSelectedWebsites($event)">
                            <template slot="option" slot-scope="{ option }">
                                <div v-if="option.$isLabel" class="text-uppercase"><strong>{{ option.$groupLabel }}</strong>
                                </div>
                                <div v-else>
                                    <input type="checkbox" :value="option" v-model="getSelectedWebsites">
                                    <span class="option__title ml-3">{{ option }}</span>
                                </div>
                            </template>
                        </multiselect>
                    </div>
                    <div>
                        <button class="btn primarycolor" @click="clearBrandStorage">Reset</button>
                    </div>
                    <div>
                        <button class="btn primarycolor" @click="getSQLStatus">Submit</button>
                    </div>
                    <div>
                        <datepicker placeholder="From" @input="getSQLStatus" v-model="startDate" />
                    </div>

                </div>
                <div class="right-card">
                    <div class="mx-4 text-center">
                        <div class="p-0" style="font-size: 14px; font-weight: 600; color: var(--primary_brand);">Last
                            Data Sync</div>
                        <div style="font-size: 12px;">{{ lastDataSync }}</div>
                    </div>
                    <div class="mx-4 text-center">
                        <div class="p-0" style="font-size: 14px; font-weight: 600; color: var(--primary_brand);">Last
                            Review Sync</div>
                        <div style="font-size: 12px;">{{ lastReviewSync }}</div>
                    </div>

                    <!-- </div> -->
                </div>
            </div>
            <div class="card mx-2">
                <div class="d-flex justify-content-end mb-4" :class="{ 'justify-content-between': selectMultiple }">
                    <div class="d-flex" v-if="selectMultiple">
                        <div class="mr-2">
                            <strong style="color: var(--primary_brand)">Start Date</strong>
                            <datepicker v-model="syncAllStartDate" />
                        </div>
                        <div class="mr-2">
                            <strong style="color: var(--primary_brand)">End Date</strong>
                            <datepicker v-model="syncAllEndDate" />
                        </div>
                        <div title="Sync All" class="align-self-end">
                            <button class="btn primarycolor" @click="syncData('all')">
                                Sync Selected
                            </button>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div title="Sync All" class="mr-2">
                            <button class="btn primarycolor" @click="selectMultiple = !selectMultiple">
                                Sync Multiple
                            </button>
                        </div>
                        <div>
                            <b-button :variant="flags.synced ? 'success' : 'outline-success'"
                                style="margin-right: 10px; padding: 6px; font-size: 12px"
                                @click="toggleFilter('synced')">Synced</b-button>
                            <b-button :variant="flags.error ? 'danger' : 'outline-danger'"
                                style="margin-right: 10px; padding: 6px; font-size: 12px"
                                @click="toggleFilter('error')">Error</b-button>
                            <b-button :variant="flags.running ? 'primary' : 'outline-primary'"
                                style="margin-right: 10px; padding: 6px; font-size: 12px"
                                @click="toggleFilter('running')">Running</b-button>
                            <b-button :variant="flags.unscheduled ? 'secondary' : 'outline-secondary'"
                                style="padding: 6px; font-size: 12px; filter: brightness(80%)"
                                @click="toggleFilter('unscheduled')">Unscheduled</b-button>
                        </div>
                    </div>
                </div>
                <div v-if="!filteredSQLData.length" class="alert alert-warning">No data</div>
                <table id="sqlTable" class="rounded-corners w-100" v-if="filteredSQLData.length">
                    <tbody>
                        <tr v-for="row of  filteredSQLData" :key="row.website_name">
                            <td style="width: 200px;">{{ row.website_name }}</td>
                            <td class="text-left d-flex" v-if="selectMultiple">
                                <span v-for="(categoryVal, categoryKey) of  row.categories "
                                    :class="categoryPills(categoryVal)" :title="categoryVal.latest_info"
                                    :key="row.website_name + categoryKey" class="alert d-flex align-items-center"
                                    style="cursor: pointer; padding: 4px; margin-right: 4px; margin-bottom: 4px;"
                                    @click="(categoryVal.checked = !categoryVal.checked); toggleCheckStatus(row.website_name, categoryKey)">
                                    <input type="checkbox" v-model="categoryVal.checked" class="mr-1" />
                                    <span style="font-size: 14px;">{{
                                        categoryKey }}</span>
                                </span>
                            </td>
                            <td class="text-left d-flex" v-else>
                                <span v-for="(categoryVal, categoryKey) of  row.categories "
                                    :class="categoryPills(categoryVal)" :title="categoryVal.latest_info" :key="categoryKey"
                                    class="alert d-flex align-items-center"
                                    style="cursor: pointer; padding: 4px; margin-right: 4px; margin-bottom: 4px;"
                                    :for="categoryKey">
                                    <span style="font-size: 14px;"
                                        @click="openModal(row.website_name, categoryKey, categoryVal.logs)">{{
                                            categoryKey }}</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <b-modal class="customModal" size="lg" :title="modalTitle" v-model="isModal">
            <div id="spiderInfo" class="mt-8">
                <b-tabs pills card>
                    <b-tab title="Logs">
                        <b-card-text>
                            <table id="modalTable" class="rounded-corners w-100">
                                <thead>
                                    <tr style="font-size: 15px !important;">
                                        <th>Timestamp</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for=" row  of  modalRows">
                                        <td>{{ row.timestamp || "-" }}</td>
                                        <td>{{ row.start_date ? moment(row.start_date).format("YYYY-MM-DD") : "-" }}</td>
                                        <td>{{ row.end_date ? moment(row.end_date).format("YYYY-MM-DD") : "-" }}</td>
                                        <td style="word-break: break-all;">{{ row.info ? row.info : row.status }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Sync">
                        <div>
                            <div class="mb-2">
                                <strong style="color: var(--primary_brand)">Start Date</strong>
                                <datepicker v-model="syncStartDate" />
                            </div>
                            <div class="mb-2">
                                <strong style="color: var(--primary_brand)">End Date</strong>
                                <datepicker v-model="syncEndDate" />
                            </div>
                            <div style="margin-top: 19px !important;">
                                <button class="btn btn-block primarycolor" @click="syncData('individual')">Sync Now</button>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>

        </b-modal>
        <!-- <b-modal class="customModal" size="lg" title="Sync All" v-model="isSyncAllModal" @hidden="resetAllSync">
            <div id="spiderInfo" class="mt-8">
                <div>
                    <div class="d-flex justify-content-between">
                        <div class="customMultiselect w-50 mr-3">
                            <multiselect v-model="selectedSyncCategory" :options="syncCategories" :multiple="false"
                                :searchable="true" placeholder="Select Category" selectLabel=""
                                @input="processSyncWebsites" />
                        </div>
                        <div class="customMultiselect w-50" v-show="syncWebsitesList.length">
                            <multiselect v-model="selectedSyncWebsites" :options="syncWebsitesList" :multiple="true"
                                :searchable="true" placeholder="Select Website(s)" selectLabel=""
                                :close-on-select="false" />
                        </div>
                    </div>
                    <div class="mb-2">
                        <strong style="color: var(--primary_brand)">Start Date</strong>
                        <datepicker v-model="syncAllStartDate" />
                    </div>
                    <div class="mb-2">
                        <strong style="color: var(--primary_brand)">End Date</strong>
                        <datepicker v-model="syncAllEndDate" />
                    </div>
                    <div style="margin-top: 19px !important;">
                        <button class="btn btn-block primarycolor" @click="syncData('all')">Sync Now</button>
                    </div>
                </div>
            </div>

        </b-modal> -->

    </div>
</template>
  
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import Loader from "../Components/Loader.vue";

export default {
    name: "AdminSQLSync",
    components: {
        Datepicker,
        Multiselect,
        Loader
    },

    data() {
        return {
            spiderData: [],
            isSpiderModal: false,
            websiteMenuItems: [],
            categoryMapper: {},
            moment: moment,
            loader: false,
            loader1: false,
            modalLoader: false,
            selectedWebsites: [],
            modifiedSelectedWebsites: [],
            startDate: moment().format("YYYY-MM-DD"),
            lastDataSync: "",
            lastReviewSync: "",
            sqlTableData: [],
            modalTitle: "",
            isModal: false,
            modalRows: [],
            flags: {
                synced: true,
                error: true,
                running: true,
                unscheduled: true
            },
            syncStartDate: moment().subtract(1, 'week').format("YYYY-MM-DD"),
            syncEndDate: moment().format("YYYY-MM-DD"),
            totalWebsiteLength: 0,
            modalWebsite: "",
            modalDataType: "",
            checkedMultipleSyncList: {},
            syncAllStartDate: moment().subtract(1, 'week').format("YYYY-MM-DD"),
            syncAllEndDate: moment().format("YYYY-MM-DD"),
            selectMultiple: false,
            // filteredSQLData: []
        };
    },
    mounted() {
        this.getWebsiteList();
    },
    computed: {
        filteredSQLData() {
            return this.sqlTableData.filter(row => {
                for (let category of Object.values(row.categories)) {
                    if ((this.flags.synced && category.latest_status === 'synced') || (this.flags.error && category.latest_status === 'error') || (this.flags.running && category.latest_status === 'running') || (this.flags.unscheduled && category.latest_status === 'unscheduled')) return true;
                }
            })

        },
        getSelectedWebsites: {
            get() {
                return this.selectedWebsites;
            },
            set() {
                this.selectedWebsites = this.modifiedSelectedWebsites;
            }
        }
    },
    methods: {
        checkEvent(checkStatus) {
            // return checkStatus
        },
        getWebsiteList() {
            this.loader = true;
            const url = "/api/sql/websitemapper";
            this.$http.post(url).then(res => {
                this.websiteMenuItems = res.body.data.websiteMenuItems;
                this.categoryMapper = res.body.data.categoryMapper;
                this.websiteMenuItems.map(dataset => {
                    dataset.options.forEach(option => {
                        this.selectedWebsites.push(option);
                        this.modifiedSelectedWebsites.push(option);
                    });
                });
                this.totalWebsiteLength = this.selectedWebsites.length;
                this.$nextTick(() => {
                    this.getSQLStatus()
                })
                this.loader = false;
            }).catch(err => {
                console.log(err);
                this.$bvToast.toast(`Error: Check console for detailed info.`, {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 3000,
                });
                this.loader = false;
            })
        },
        getSQLStatus() {
            if (!this.getSelectedWebsites.length) {
                this.$bvToast.toast(`Please select website(s) to get sync info.`, {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 3000,
                })
                return;
            }
            this.loader1 = true;
            const url = "/api/sql/status";
            let payload = {
                timestamp: moment(this.startDate).format("YYYY-MM-DD")
            }
            if (this.getSelectedWebsites.length !== this.totalWebsiteLength) {
                payload['website_names'] = this.getSelectedWebsites
            }
            this.$http.post(url, payload).then(res => {
                this.lastDataSync = res.body.last_data_sync;
                this.lastReviewSync = res.body.last_review_sync;
                this.sqlTableData = res.body.data;
                this.sqlTableData.forEach(datapoint => {
                    Object.keys(datapoint.categories).forEach(categoryKey => {
                        datapoint.categories[categoryKey] = { ...datapoint.categories[categoryKey], checked: false };
                    })
                })
                this.loader1 = false;
            }).catch(err => {
                console.log(err);
                this.$bvToast.toast(`Error: Check console for detailed info.`, {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 3000,
                });
                this.loader1 = false;
            })
        },
        toggleCheckStatus(websiteName, dataType) {
            if (!(websiteName in this.checkedMultipleSyncList)) {
                this.checkedMultipleSyncList = { ...this.checkedMultipleSyncList, [websiteName]: [] }
            }

            if (this.checkedMultipleSyncList[websiteName].includes(dataType)) {
                this.checkedMultipleSyncList[websiteName].splice(this.checkedMultipleSyncList[websiteName].indexOf(dataType), 1)
            } else {
                this.checkedMultipleSyncList[websiteName].push(dataType)
            }
            if (!this.checkedMultipleSyncList[websiteName].length) delete this.checkedMultipleSyncList[websiteName];


        },
        syncData(typeFlag) {
            if (new Date(this.syncEndDate) < new Date(this.syncStartDate)) {
                this.$bvToast.toast(`Start date can not be greater than the end date.`, {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 3000,
                })
                return;
            }
            // this.loader = true;
            const url = "/api/sql/sync";
            let payload = {};
            if (typeFlag === 'individual') {
                payload = {
                    start_date: moment(this.syncStartDate).format("YYYY-MM-DD"),
                    end_date: moment(this.syncEndDate).format("YYYY-MM-DD"),
                    insert_date: moment(this.syncEndDate).format("YYYY-MM-DD"),
                    websites_data: [
                        {
                            website_name: this.modalWebsite,
                            data_type: this.modalDataType
                        }
                    ]
                }

            } else if (typeFlag === 'all') {
                payload = {
                    start_date: moment(this.syncAllStartDate).format("YYYY-MM-DD"),
                    end_date: moment(this.syncAllEndDate).format("YYYY-MM-DD"),
                    insert_date: moment(this.syncAllEndDate).format("YYYY-MM-DD"),
                    websites_data: []
                }

                if (!Object.keys(this.checkedMultipleSyncList).length) {
                    this.$bvToast.toast(`Please select items to sync.`, {
                        title: 'Weavr Sense',
                        variant: 'danger',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 3000,
                    })
                    return;
                }

                Object.keys(this.checkedMultipleSyncList).forEach(key => {
                    if (this.checkedMultipleSyncList[key].length) {
                        this.checkedMultipleSyncList[key].forEach(checkedItem => {
                            payload.websites_data.push({
                                website_name: key,
                                data_type: checkedItem
                            })
                        })
                    }
                })
            }

            this.$http.post(url, payload).then(res => {
                this.resetAllSync();
                this.resetModal();
                this.loader = false;
                this.$bvToast.toast(`Sync started.`, {
                    title: 'Weavr Sense',
                    variant: 'success',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 3000,
                })
            }).catch(err => {
                console.log(err);
                this.$bvToast.toast(`Error: Check console for detailed info.`, {
                    title: 'Weavr Sense',
                    variant: 'danger',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 3000,
                });
                this.loader = false;
            })
        },
        openModal(websiteName, categoryName, rowData) {
            this.isModal = true;
            this.modalTitle = `${websiteName}: ${categoryName}`;
            this.modalWebsite = websiteName;
            this.modalDataType = categoryName;
            this.modalRows = rowData;
        },
        resetModal() {
            this.syncStartDate = moment().subtract(1, 'week').format("YYYY-MM-DD");
            this.syncEndDate = moment().format("YYYY-MM-DD");
            this.modalDataType = "";
            this.modalWebsite = "";
            this.modalRows = [];
            this.modalTitle = "";
            this.isModal = false;
        },

        resetAllSync() {
            this.sqlTableData.forEach(datapoint => {
                Object.keys(datapoint.categories).forEach(categoryKey => {
                    datapoint.categories[categoryKey].checked = false;
                })
            })
            this.checkedMultipleSyncList = {};
            this.selectMultiple = false
            this.syncAllStartDate = moment().subtract(1, 'week').format("YYYY-MM-DD");
            this.syncAllEndDate = moment().format("YYYY-MM-DD");
        },
        toggleFilter(filterName) {
            this.flags[filterName] = !this.flags[filterName]
        },
        categoryPills(categoryVal) {
            if (categoryVal.latest_status === 'synced') {
                if (this.flags.synced) return 'alert-success'
                else return 'd-none'
            } else if (categoryVal.latest_status === 'error') {
                if (this.flags.error) return 'alert-danger'
                else return 'd-none'
            } else if (categoryVal.latest_status === 'running') {
                if (this.flags.running) return 'alert-primary'
                else return 'd-none'
            } else if (categoryVal.latest_status === 'unscheduled') {
                if (this.flags.unscheduled) return 'alert-secondary'
                else return 'd-none'
            }
        },
        setSelectedWebsites(items) {
            if (typeof (items) === 'object') {
                for (let i = 0; i < items.length; i++) {
                    this.modifiedSelectedWebsites.push(items[i]);
                }
            } else {
                this.modifiedSelectedWebsites.push(items);
            }
        },
        removeSelectedWebsites(items) {
            if (typeof (items) === 'object') {
                for (let i = 0; i < items.length; i++) {
                    const itemIndex = this.selectedWebsites.findIndex(item => item === items[i]);
                    if (itemIndex !== -1) {
                        this.selectedWebsites.splice(itemIndex, 1);
                    }
                }
            } else {
                const itemIndex = this.selectedWebsites.findIndex(item => item === items);
                if (itemIndex !== -1) {
                    this.selectedWebsites.splice(itemIndex, 1);
                }
            }
            this.modifiedSelectedWebsites = this.selectedWebsites;
        },
        clearBrandStorage() {
            this.selectedWebsites = [];
            this.modifiedSelectedWebsites = [];
        },
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.customMultiselect .multiselect__placeholder {
    margin-bottom: 6px !important;
    padding: 0px !important;
    color: var(--primary_brand-40) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tags {
    border: 1px solid var(--base_color-40) !important;
    padding-top: 6px !important;
    min-height: 35px !important;
    max-height: 36px !important;
    overflow-y: auto;
    font-family: "poppins";
}

.customMultiselect .multiselect__input {
    border: var(--base_color-20) !important;
    height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
    outline: none !important;
}

.customMultiselect .multiselect__select {
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
    top: 56% !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag {
    background: var(--primary_brand-80) !important;
    margin-bottom: 0px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
    color: #fff !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
    border: 1px solid var(--base_color-40) !important;
    border-top: none !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
    background: var(--red) !important;
    color: var(--white) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
    background: var(--base_color-20) !important;
    color: var(--primary_brand-80) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__element {
    color: var(--primary_brand-80) !important;
    border-bottom: 1px solid var(--base_color-20);
    font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
    background-color: #44777A !important;
    color: white !important;
    font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
    font-size: 10px !important;
    padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
    width: 10px;
    border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
    background: var(--base_color-20);
    border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
    background: var(--base_color-80);
    border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
    background: var(--base_color);
}

#missing-spider-field_length select {
    width: 50% !important;
}

#empty-spider-field_length select {
    width: 50% !important;
}

#missing-spider-field_filter {
    display: none;
}

#missing-spider-databutton.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
}

_filter {
    display: none;
}

#empty-spider-field_filter {
    display: none;
}

/* .modal-title {
    font-weight: 600 !important;
    font-family: "poppins" !important;
}

.modal-header {
    background: var(--primary_brand-20) !important;
    color: var(--base_color) !important;
    border: none !important;
    font-family: "poppins" !important;
    border-radius: 5px 0px 0px 0px !important;
    word-break: break-all;
}

.modal-header .close {
    color: black !important;
    text-shadow: none !important;
    position: absolute !important;
    top: -2px !important;
    right: -6px !important;
    font-size: 30px !important;
    background: var(--primary_brand-10) !important;
    opacity: inherit !important;
    padding: 5px 10px !important;
    border-radius: 25px !important;
} */

@media (max-width: 770px) {
    #missing-spider-data_filter {
        margin-top: -38px !important;
    }
}
</style>
<style scoped>
#SQLSync {
    font-family: "Poppins", sans-serif !important;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.top-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}

.custom_websiteMenu {
    border: 1px solid silver;
    background: white;
    width: max-content;
    position: absolute;
    z-index: 1;
    height: 300px;
    overflow-y: scroll;
    margin-left: -5px;
    border-radius: 0px 0px 5px 5px;
}

.custom_websiteMenuItems {
    font-size: 11px;
    color: var(--primary_brand);
}

.custom_optgroup {
    font-weight: bolder;
    padding-left: 9px;
    font-size: 13px;
}

.custom_option {
    padding: 8px 8px 8px 18px;
    display: flex;
    align-items: center;
    font-family: "heebo" !important;
    border-bottom: 1px solid var(--base_color-20);
}

.custom_option input {
    margin-right: 5px;
    font-size: 11px;
    accent-color: var(--primary_brand);
    width: 15px;
    height: 15px;
    font-family: "poppins";
}

.custom_option:hover {
    background: var(--base_color-10) !important;
    color: var(--primary_brand-80) !important;
    font-family: "poppins";
}

.custom_option.active {
    background: var(--primary_brand-60);
    color: white;
    font-weight: bolder;
}

.custom_dropdown {
    text-transform: uppercase;
    -youbkit-touch-callout: none;
    /* iOS Safari */
    -youbkit-user-select: none;
    /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE 10+ and Edge */
    user-select: none;
    width: 50%;
    margin-right: 8px;
    background: var(--base_color-5) !important;
    color: var(--primary_brand-80) !important;
}

.custom_dropdown_wrap {
    cursor: pointer;
    display: flex;
    border: 1px solid silver;
    border-radius: 5px;
    background: white;
    justify-content: space-between;
    padding: 7px;
    height: 34px !important;
}

.custom_dropdown_title {
    font-size: 11px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

select option {
    text-transform: capitalize !important;
    padding: 10px 0px !important;
}

select {
    font-family: "Poppins", sans-serif !important;
}

customSelect {
    background: var(--base_color-5) !important;
    color: var(--primary_brand-60) !important;
    border: 1px solid var(--primary_brand-60) !important;
}

.customSelect:focus {
    background: var(--base_color-5) !important;
    color: var(--primary_brand-60) !important;
    border: 1px solid var(--primary_brand-60) !important;
    outline: none !important;
    box-shadow: none !important;
    font-weight: 600 !important;
}

.form-control {
    border-radius: 5px !important;
    padding: 6px !important;
    font-size: 11px !important;
    height: 35px !important;
    border: 1px solid var(--base_color-40) !important;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
    border: none !important;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
}

.linkHover:hover {
    text-decoration: underline;
}

/* IE fix */
#card-chart-01,
#card-chart-02 {
    width: 100% !important;
}

.card_vivo {
    background-color: #0072ba !important;
    border: 1px solid #0072ba !important;
}

.card_realme {
    background-color: #f3b821 !important;
    border: 1px solid #f3b821 !important;
}

.card_redmi {
    background-color: #f56628 !important;
    border: 1px solid #f56628 !important;
}

.badge {
    padding: 5px;
    font-size: 13px;
}

.redbg {
    background: #ffd1d1;
    color: inherit;
}

.ybg {
    background: #ffff9c;
    color: inherit;
}

.greenbg {
    color: green;
    cursor: pointer;
}

.highcharts-figure .chart-container {
    width: 300px;
    height: 200px;
    float: left;
}

.cursorPointer:hover {
    cursor: pointer;
}

.thead-normal th,
.tbody-normal td {
    border: 1px solid silver !important;
}

.thead-normal tr {
    background: rgb(138, 135, 232);
    color: white;
}

.saveBtn {
    background-color: #b4ffb3;
    border-radius: 0;
    height: 30px;
    border: none;
    width: 60px;
}

.custom_dropdown {
    text-transform: uppercase;
    -youbkit-touch-callout: none;
    /* iOS Safari */
    -youbkit-user-select: none;
    /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* IE 10+ and Edge */
    user-select: none;
}

.custom_dropdown_wrap {
    cursor: pointer;
    display: flex;
    border: 1px solid silver;
    background: white;
    justify-content: space-between;
    padding: 6px;
    height: 30px;
}

.custom_dropdown_title {
    font-size: 11px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.customInput {
    border-radius: 5px !important;
    height: 35px !important;
    border: 1px solid var(--primary_brand-60);
    width: 220px;
    outline: none;
}

.customInput:focus {
    border: 1px solid var(--primary_brand) !important;
}

.customInput::placeholder {
    color: var(--primary_brand-40);
}

.custom_websiteMenu {
    border: 1px solid silver;
    background: white;
    width: max-content;
    position: absolute;
    z-index: 1;
    height: 300px;
    overflow-y: scroll;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
}

.custom_websiteMenuItems {
    font-size: 11px;

    color: #5c6873;
}

.custom_optgroup {
    font-weight: bolder;
    padding-left: 9px;
}

.custom_option {
    padding-left: 18px;
}

.custom_option:hover {
    background: #23a8d8;
    color: white;
    font-weight: bolder;
}

.custom_option.active {
    background: #1a88af;
    color: white;
    font-weight: bolder;
}

.mycol {
    padding-right: 15px !important;
    padding-left: 15px !important;
}

.mycols:first-child {
    padding-right: 2px !important;
}

.mycols:last-child {
    padding-left: 2px;
}

.mycols:not(:first-child):not(:last-child) {
    padding-left: 2px;
    padding-right: 2px;
}

.mycols:nth-child(7n) {
    padding-left: 15px !important;
}

.mycols:nth-child(6n) {
    padding-right: 15px !important;
}

#sqlTable td {
    padding: 10px !important;
    font-family: "Poppins" sans-serif !important;
}

#sqlTable {
    background: transparent !important;
}

#sqlTable td:first-child {
    text-align: left !important;
    background: var(--background) !important;
    font-weight: bolder !important;
}

.spiderlogsmsg {
    max-height: 178px;
    overflow: auto;
    max-width: 440px;
    font-size: 11px;
    background: whitesmoke;
    padding: 10px;
}

.left-card {
    display: flex;
    gap: 6px;
    justify-content: space-between;
    width: 60%;
}

.right-card {
    display: flex;
    justify-content: flex-end;
    width: 40%;
}

@media (max-width: 1700px) {
    .left-card {
        justify-content: flex-start;
    }
}

@media (max-width: 1520px) {
    .datebox {
        padding-bottom: 0;
    }
}

@media (max-width: 580px) {
    .top-card {
        flex-direction: row;
        gap: 10px;
    }

    .left-card {
        flex-direction: column;
        gap: 10px;
        height: 50%;
    }

    .left-card>div {
        width: 100% !important;
    }

    .right-card {
        flex-direction: column;
        gap: 10px;
    }

    .right-card>div {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .right-card button {
        margin-right: 0 !important;
    }
}

@media (max-width: 790px) {
    .scrolled-table {
        max-width: 100vw;
        overflow-x: auto;
    }

    .action-btn-grp {
        width: 50%;
    }
}
</style>
  